module.exports = __webpack_public_path__ + "static/media/entImg.7ade1a60.png";